import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientBulkUpdateListController from '../../../../Controllers/AdminScreens/Services/Settings/ClientBulkUpdateListController';
import Dropdown from '../../../../../Components/Dropdown';
import TextInput from '../../../../../Components/TextInput';
import CheckBox from '../../../../../Components/CheckBox';
import search from '../../../../../Assets/Icons/search.png';
import editIcon from '../../../../../Assets/Icons/edit.png';
import deleteIcon from '../../../../../Assets/Icons/delete.png';
import downArrow from '../../../../../Assets/Icons/chevron-down.png';
import BulkUpdateClientInformationModal from '../../../../../Components/Modals/BulkUpdateClientInformationModal';
import Loader from '../../../../../Components/Loader';
import DeleteConfirmationModal from '../../../../../Components/Modals/DeleteConformationModal';
import NoDataCard from '../../../../../Components/NoDataCard';

const ClientBulkUpdateListScreen = () => {
    const navigate = useNavigate();

    const [selectAll, setSelectAll] = useState(false);
    const [checkedStates, setCheckedStates] = useState({});
    const [selectedClients, setSelectedClients] = useState([]);

    const [filters, setFilters] = useState({
        location: '',
        taskLeader: '',
        services: '',
    });

    const {
        tasks,
        currentClientList,
        currentPage,
        totalPages,
        handlePageChange,
        toggleDetails,
        userPermissions,
        modalVisible,
        handleCloseBulkUpdateModalModalModal,
        addBulkUpdateModalModalVisible,

        serviceOptions,
        servicesLoading,
        servicesError,
        serviceName,
        setServiceName,

        teamLeadError,
        employeeList,
        teamLeaderLoading,

        handleSearchClient,
        handleSelectClient,
        selectedClient,
        loading,
        clientNameError,
        clientList,
        searchUser,
        setSearchUser,

        setTeamLeader,
        teamLeader,
        setLocation,
        location,
        setGroupName,
        groupName,
        assignedUser,
        setAssignedUser,
        handleSubServices,
        groupLoading,
        groupNameError,
        groupList,
        handleGroupNameSearch,
        handleSelectGroup,
        handleSelectAssignedUser,
        assignedUserLoading,
        assignedUserError,
        assignedUserList,
        handleAssignedUserSearch,
        loacationList,
        loacationError,
        loacationLoading,
        handleLocationSearch,
        handleSelectLocation,
        handleBulkUpdateFilter,
        bulkUpdateError,
        bulkUpdateLoading,
        bulkUpdateClientList,
        bulkUplodaFilterError,
        setBulkUploadFilterError,
        setLoacationError,
        setAssignedUserError,
        setGroupNameError,
        setClientNameError,
        handleCloseDeleteModal,
        handleOpenDeleteModal,
        isDeleteModalOpen,
        selectedClientToDelete,
        handleDelete,
        setBulkUpdateClientList,
        selectBulkClientsError,
        setSelectBulkClientsError,
        handleCancleClick,
        setSelectedGroup,
        setSelectedClient,
        setSelectedAssignedUser,
        setSelectedLocation,handleClientValue,handleGroupValue,handleCityValue,handleUserValue
    } = ClientBulkUpdateListController(selectedClients,setCheckedStates,setSelectAll,setSelectedClients);

    // console.log("selectedClientToDelete", selectedClientToDelete)

    const resetFilters = () => {
        setSearchUser('');
        setTeamLeader('');
        setLocation('');
        setAssignedUser('');
        setGroupName('');
        setServiceName('');
        setBulkUploadFilterError('');
        setLoacationError('');
        setAssignedUserError('');
        setGroupNameError('');
        setClientNameError('');
        setSelectBulkClientsError('');
        setSelectedGroup(null);
        setSelectedClient(null);
        setSelectedAssignedUser(null);
        setSelectedLocation(null);
    };

    const toggleFilters = () => {
        setSearchUser('');
        setTeamLeader('');
        setLocation('');
        setAssignedUser('');
        setGroupName('');
        setServiceName('');
        setBulkUploadFilterError('');
        setLoacationError('');
        setAssignedUserError('');
        setGroupNameError('');
        setClientNameError('');
        setSelectBulkClientsError('');
        setSelectedGroup(null);
        setSelectedClient(null);
        setSelectedAssignedUser(null);
        setSelectedLocation(null);
    };

    const handleNav = (task) => {
        navigate('/manage-clients', { state: { task: 'PrimaryInformation', clientId: task?.client_id } })
    };

    const handleSelectAll = (isChecked) => {
        setSelectAll(isChecked);
    
        if (isChecked) {
            // Select all clients from the bulk list
            const allClientIds = bulkUpdateClientList.map(client => client.client_id);
            setCheckedStates(prev => {
                const newStates = { ...prev };
                allClientIds.forEach(id => newStates[id] = true);
                return newStates;
            });
            setSelectedClients([...bulkUpdateClientList]); 
        } else {
            // Unselect all clients
            setCheckedStates({});
            setSelectedClients([]);
        }
    };
    
    const handleCheckboxChange = (clientId, isChecked) => {
        setCheckedStates(prev => ({
            ...prev,
            [clientId]: isChecked
        }));
    
        let updatedSelectedClients = [...selectedClients];
    
        if (isChecked) {
            const selectedClient = bulkUpdateClientList.find(client => client.client_id === clientId);
            if (selectedClient) {
                updatedSelectedClients.push(selectedClient);
            }
        } else {
            updatedSelectedClients = updatedSelectedClients.filter(client => client.client_id !== clientId);
        }
    
        setSelectedClients(updatedSelectedClients);
    
        // Check if all checkboxes are selected across all pages
        const allChecked = bulkUpdateClientList.every(client => updatedSelectedClients.some(selected => selected.client_id === client.client_id));
        setSelectAll(allChecked);
    };
    
    
    

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();


    return (
        <>
            <div className='flexdisplaybetween' style={{ paddingBottom: '10px' }}>
                <h2 >Search Clients</h2>
                <div className='add-popup-buttons' style={{ fontSize: 12 }}>Bulk Import</div>
            </div>
            <div className="basic-info-outer-card" style={{ borderBottom: '1px solid #EFF0F4' }}>
                <div className="tasksScreen-open-filters">
                    <div className="tasksScreen-filters" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))" }}>
                        <div className="filter-field" style={{ paddingBottom: '10px' }}>
                            <label>Search Client</label>
                            <TextInput
                                type="text"
                                placeholder="Enter client name"
                                value={searchUser}
                                onChange={(e) => handleClientValue(e.target.value)}
                                onRightClick={handleSearchClient}
                                right={
                                    loading ? (
                                        <Loader loading={loading} color={'var(--primary-color)'} size='small' /> // Show loader when loading
                                    ) : (
                                        <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                    )
                                }
                                errorMessage={clientNameError}
                            />
                            {clientList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {clientList.map((client, index) => (
                                        <li
                                            key={client?.client_id}
                                            onClick={() => handleSelectClient(client)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                            }}
                                        >
                                            {client?.client_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="filter-field" style={{ paddingBottom: '10px' }}>
                            <label>Group Name</label>
                            <TextInput
                                type="text"
                                placeholder="Enter group name"
                                value={groupName}
                                onChange={(e) => handleGroupValue(e.target.value)}
                                onRightClick={handleGroupNameSearch}
                                right={
                                    groupLoading ? (
                                        <Loader loading={groupLoading} color={'var(--primary-color)'} size='small' /> // Show loader when loading
                                    ) : (
                                        <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                    )
                                }
                                errorMessage={groupNameError}
                            />
                            {groupList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {groupList?.map((group, index) => (
                                        <li
                                            key={group?.group_id}
                                            onClick={() => handleSelectGroup(group)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== groupList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                            }}
                                        >
                                            {group?.group_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="filter-field" style={{ paddingBottom: '10px' }}>
                            <label>Assigned User</label>
                            <TextInput
                                type="text"
                                placeholder="Enter assigned user"
                                value={assignedUser}
                                onChange={(e) => handleUserValue(e.target.value)}
                                onRightClick={handleAssignedUserSearch}
                                right={
                                    assignedUserLoading ? (
                                        <Loader loading={assignedUserLoading} color={'var(--primary-color)'} size='small' /> // Show loader when loading
                                    ) : (
                                        <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                    )
                                }
                                errorMessage={assignedUserError}
                            />
                            {assignedUserList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {assignedUserList?.map((user, index) => (
                                        <li
                                            key={user?.user_id}
                                            onClick={() => handleSelectAssignedUser(user)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== assignedUserList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                            }}
                                        >
                                            {user?.emp_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        {/* <Dropdown
                            ref={(el) => (dropdownRefs.current["Location"] = el)}
                            isOpen={openDropdown === "Location"}
                            toggleDropdown={() => toggleDropdown("Location")}
                            label="Location"
                            options={loacationList}
                            value={location}
                            onChange={(value) => setLocation(value)}
                            loading={loacationLoading}
                            errorMessage={loacationError}
                        /> */}
                        <div className="filter-field" style={{ paddingBottom: '10px' }}>
                            <label>City</label>
                            <TextInput
                                type="text"
                                placeholder="Enter city"
                                value={location}
                                onChange={(e) => handleCityValue(e.target.value)}
                                onRightClick={handleLocationSearch}
                                right={
                                    loacationLoading ? (
                                        <Loader loading={loacationLoading} color={'var(--primary-color)'} size='small' /> // Show loader when loading
                                    ) : (
                                        <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                    )
                                }
                                errorMessage={loacationError}
                            />
                            {loacationList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {loacationList?.map((location, index) => (
                                        <li
                                            key={location}
                                            onClick={() => handleSelectLocation(location)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== loacationList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                            }}
                                        >
                                            {location?.location}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <Dropdown
                            ref={(el) => (dropdownRefs.current["Team Leader"] = el)}
                            isOpen={openDropdown === "Team Leader"}
                            toggleDropdown={() => toggleDropdown("Team Leader")}
                            label="Team Leader"
                            options={employeeList}
                            value={teamLeader}
                            onChange={(selectedOption) => setTeamLeader(selectedOption)}
                            loading={teamLeaderLoading}
                            errorMessage={teamLeadError}
                        />

                        <Dropdown
                            ref={(el) => (dropdownRefs.current["Services"] = el)}
                            isOpen={openDropdown === "Services"}
                            toggleDropdown={() => toggleDropdown("Services")}
                            label="Services"
                            options={serviceOptions}
                            value={serviceName}
                            onChange={(selectedOption) => handleSubServices(selectedOption)}
                            loading={servicesLoading}
                            errorMessage={servicesError}
                        />

                    </div>

                    <div className="tasksScreen-filter-buttons">
                        <button onClick={handleBulkUpdateFilter} className="tasksScreen-apply-button" style={{
                            cursor: bulkUpdateLoading ? "not-allowed" : "pointer",
                            opacity: bulkUpdateLoading ? 0.6 : 1,
                            pointerEvents: bulkUpdateLoading ? 'none' : 'auto',
                            gap: '5px',
                            display: 'flex'
                        }} disabled={bulkUpdateLoading}>{bulkUpdateLoading &&
                            <span style={{ paddingRight: 5 }} ><Loader loading={bulkUpdateLoading} color={'var(--background-color)'} size="small" /> </span>
                            } Apply</button>
                        <button onClick={toggleFilters} className="tasksScreen-cancel-button">Cancel</button>
                        <button onClick={resetFilters} className="tasksScreen-reset-button">Reset</button>
                        {bulkUplodaFilterError && <div className="list-error-msg">{bulkUplodaFilterError} </div>}
                    </div>
                </div>
            </div>
            <div style={{ paddingTop: '50px' }}>
                <div className="basic-info-outer-card" style={{ paddingTop: '10px ' }}>
                    <table className="tasksScreen-task-table" >
                        <thead>
                            <tr >
                                <th style={{ width: "5%" }}>
                                    {/* <input type="checkbox" /> */}
                                    <CheckBox
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th style={{ width: "20%", }}>Client Name</th>
                                <th style={{ width: "15%", }}>Group Name</th>
                                <th style={{ width: "13%", }}>Assigned to</th>
                                <th style={{ width: "12%", }}>Team Leader</th>
                                <th style={{ width: "10%", }}>Location</th>
                                <th style={{ width: "15%", }}>Services</th>
                                <th style={{ width: "10%", }}></th>
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: 'white' }}>
                            {currentClientList?.map((client, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        borderBottom: "3px solid #f8f9fa",
                                    }}
                                >
                                    <td >
                                        {/* <input type="checkbox" /> */}
                                        <CheckBox
                                            checked={checkedStates[client?.client_id] || false}
                                            onChange={(isChecked) => handleCheckboxChange(client?.client_id, isChecked)}
                                        />

                                    </td>
                                    <td>{client?.client_name ||'--'}</td>
                                    <td>{client?.group_name||'--'}</td>
                                    <td>{client?.employee_id_assigned_name||'--'}</td>
                                    <td>{client?.emp_id_team_lead_name||'--'}</td>
                                    <td>{client?.client_city||'--'}</td>
                                    <td>{client?.combined_service_name||'--'}</td>
                                    <td
                                    >
                                        {userPermissions?.services_sett?.per_name_sub_json?.client_list === 1 &&
                                            <button className="tasksScreen-edit-button" >
                                                <img src={editIcon} alt="Edit" onClick={() => handleNav(client)} style={{ height: '16px', width: '16px'}} />
                                                {/* <img src={editIcon} alt="Edit" /> */}
                                            </button>
                                        }
                                        <button className="tasksScreen-delete-button">
                                            <img src={deleteIcon} alt="Delete" onClick={() => { handleDelete(client, index) }} style={{ height: '16px', width: '16px'}} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {bulkUpdateError && <NoDataCard
                                            message={bulkUpdateError}
                                        />}
                    {bulkUpdateLoading && <Loader loading={bulkUpdateLoading} color={'var(--primary-color)'} />}
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div className="button-container">
                    <button className="add-client-button" onClick={addBulkUpdateModalModalVisible}>Bulk Update</button>
                    <button className="tasksScreen-cancel-button" style={{marginLeft:'10px'}} onClick={handleCancleClick}>Cancel</button>
                    {selectBulkClientsError && <div className="list-error-msg">{selectBulkClientsError} </div>}
                </div>
                <div className="tasksScreen-table-footer">
                    <span className="tasksScreen-pagination-info">
                        {`${currentPage}-${totalPages} of items`}
                    </span>
                    <div className="tasksScreen-pagination">
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
                            <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image " />
                        </button>
                        {/* {[...Array(totalPages)].map((_, index) => (
                        <button key={index} className={`tasksScreen-pagination-button ${currentPage === index + 1 ? 'active' : ''}`} onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    ))} */}
                        {/* Page Numbers */}
                        {visiblePages.map((page) => (
                            <button
                                key={page}
                                className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                            <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                        </button>
                    </div>
                </div>
            </div>
            <BulkUpdateClientInformationModal isOpen={modalVisible} onClose={handleCloseBulkUpdateModalModalModal} selectedClients={selectedClients} handleCancleClick={handleCancleClick}/>
            <DeleteConfirmationModal
                    isOpen={isDeleteModalOpen}
                    message={`Are you sure you want to delete ${selectedClientToDelete?.client?.client_name}?`}
                    onClose={handleCloseDeleteModal}
                    onConfirm={() => {
                        // // Remove client from the bulkUpdateClientList
                        // setBulkUpdateClientList(prevList => 
                        //     prevList?.filter(client => client?.client_id !== selectedClientToDelete?.client?.client_id)
                        // );
                
                        // // Update selected clients list
                        // setSelectedClients(prevSelected =>
                        //     prevSelected?.filter(client => client?.client_id !== selectedClientToDelete?.client?.client_id)
                        // );

                        const updatedList = bulkUpdateClientList?.filter(client => client?.client_id !== selectedClientToDelete?.client?.client_id);
                        setBulkUpdateClientList(updatedList);

                        // Remove client from selectedClients
                        const updatedSelectedClients = selectedClients?.filter(client => client?.client_id !== selectedClientToDelete?.client?.client_id);
                        setSelectedClients(updatedSelectedClients);

                        // Uncheck "Select All" if no clients are left
                        if (updatedList?.length === 0 || updatedSelectedClients?.length === 0) {
                            setSelectAll(false);
                        }

                        handleCloseDeleteModal();
                    }}
                />
        </>
    );
};

const styles = {
    dropdownList: {
        position: 'absolute',
        top: '85%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};


export default ClientBulkUpdateListScreen;
